import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import 'core-js/modules/es.object.assign.js';
import { __awaiter } from '../../../../_virtual/_tslib.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { styled, Stack, shape, palette, withUtility, css, spacing, Text, ModalTitle, ModalContent, ModalActions, Button } from '@hub-la/design-system';
import { useGetAssetsSignedUrl, UploadStatus } from '@hub-la/fe-asset';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import CloseIcon from '@mui/icons-material/Close';
import FolderOpenOutlinedIcon from '@mui/icons-material/FolderOpenOutlined';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import VideoFileOutlinedIcon from '@mui/icons-material/VideoFileOutlined';
import { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import '@hub-la/fe-container';
import '@mui/material';
import 'react-query';
import '../../../i18n.js';
import '@hub-la/fe-core-http-client';
import '../../../usecases/save-file.js';
import '../../../domain/dtos/query-key.js';
import '../../../usecases/save-post.js';
import { VideosUploaderContext } from '../../providers/videos-uploader-provider.js';
import { ResponsiveModal } from '../responsive-modal/responsive-modal.js';
import { Input } from './input.js';

let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7;
const Icon = styled(Stack)(_t || (_t = _`
  width: 56px;
  height: 56px;
  justify-content: center;
  align-items: center;
  border-radius: ${0};
  background-color: ${0};
`), shape('extraLarge'), palette('surfaceAt2'));
const Card = styled(Stack)(_t2 || (_t2 = _`
  width: 100%;
  height: 328px;
  border: 1px solid ${0};
  border-radius: ${0};
  overflow-x: hidden;
`), palette('surfaceVariant'), shape('small'));
const Uploader = styled('label')(_t3 || (_t3 = _`
  ${0};

  border-radius: ${0};
  width: 100%;
  cursor: pointer;
`), withUtility(({
  palette
}, {
  type
}) => {
  if (type === 'card') {
    return css(_t4 || (_t4 = _`
        justify-content: center;
        align-items: center;
        height: 100%;
        display: flex;
        flex-direction: column;
      `));
  }
  return css(_t5 || (_t5 = _`
      border: 1px solid ${0};
      height: 48px;
      margin-bottom: ${0};
    `), palette('surfaceVariant'), spacing(2));
}), shape('small'));
const Item = styled(Stack)(_t6 || (_t6 = _`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: ${0};

  &:hover {
    background-color: ${0};
    border-radius: ${0};
  }
`), spacing(2), palette('surfaceAt1'), shape('small'));
const FileName = styled(Text)(_t7 || (_t7 = _`
  word-wrap: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`));
const SendVideos = ({
  open: _open = false,
  onClose,
  sectionId
}) => {
  useTranslation();
  const [videos, setVideos] = useState([]);
  const {
    add
  } = useContext(VideosUploaderContext);
  const {
    mutateAsync,
    isLoading
  } = useGetAssetsSignedUrl();
  const hasVideos = videos.length > 0;
  const handleDeleteVideo = name => () => {
    setVideos(videos.filter(video => video.file.name !== name));
  };
  const addVideos = () => __awaiter(void 0, void 0, void 0, function* () {
    const signedUrls = yield mutateAsync({
      assets: videos.map(({
        file
      }) => ({
        name: file.name,
        mimeType: file.type
      })),
      sectionId
    });
    add(videos.map(video => Object.assign(Object.assign({}, video), {
      asset: signedUrls.find(signedUrl => signedUrl.asset.name === video.file.name).asset,
      writeUrl: signedUrls.find(signedUrl => signedUrl.asset.name === video.file.name).writeUrl,
      status: UploadStatus.NO_CALLED
    })));
    setVideos([]);
    onClose();
  });
  return jsx(ResponsiveModal, Object.assign({
    open: _open,
    onClose: onClose
  }, {
    children: jsxs(Fragment, {
      children: [jsx(ModalTitle, {
        children: jsx(Text, Object.assign({
          variant: "h3",
          color: "onSurface"
        }, {
          children: "Enviar v\u00EDdeos em massa"
        }))
      }), jsxs(Stack, Object.assign({
        flexDirection: "column"
      }, {
        children: [jsx(Text, Object.assign({
          variant: "body2",
          color: "outline",
          marginBottom: 1
        }, {
          children: "Voc\u00EA pode adicionar v\u00E1rios v\u00EDdeos de uma vez. Cada v\u00EDdeo ser\u00E1 uma publica\u00E7\u00E3o em rascunho na se\u00E7\u00E3o e usaremos o nome do arquivo como t\u00EDtulo."
        })), jsx(Text, Object.assign({
          variant: "body2",
          color: "outline"
        }, {
          children: "Aviso importante: V\u00EDdeos em rascunho ser\u00E3o deletados ap\u00F3s 45 dias."
        }))]
      })), jsx(ModalContent, {
        children: jsx(Card, Object.assign({
          padding: hasVideos ? 4 : 0,
          overflow: hasVideos ? 'scroll' : 'none'
        }, {
          children: hasVideos ? jsxs(Stack, Object.assign({
            flexDirection: "column"
          }, {
            children: [jsx(Uploader, Object.assign({
              type: "item"
            }, {
              children: jsxs(Stack, Object.assign({
                paddingX: 2,
                height: 48,
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center"
              }, {
                children: [jsx(Input, {
                  onChange: setVideos
                }), jsxs(Stack, Object.assign({
                  flexDirection: "row"
                }, {
                  children: [jsx(FolderOpenOutlinedIcon, {}), jsx(Text, Object.assign({
                    color: "onSurface",
                    marginLeft: 2
                  }, {
                    children: "Meu dispositivo"
                  }))]
                })), jsx(AddOutlinedIcon, {})]
              }))
            })), videos.map(({
              file
            }) => jsxs(Item, Object.assign({
              "data-testid": file.name
            }, {
              children: [jsxs(Stack, Object.assign({
                flexDirection: "row",
                width: "90%"
              }, {
                children: [jsx(VideoFileOutlinedIcon, {}), jsx(FileName, Object.assign({
                  marginLeft: 2
                }, {
                  children: file.name
                }))]
              })), jsx(CloseIcon, {
                style: {
                  cursor: 'pointer'
                },
                onClick: handleDeleteVideo(file.name)
              })]
            }), file.name))]
          })) : jsxs(Uploader, Object.assign({
            type: "card",
            "data-testid": "empty-state"
          }, {
            children: [jsx(Input, {
              onChange: setVideos
            }), jsx(Icon, {
              children: jsx(UploadFileIcon, {})
            }), jsx(Text, Object.assign({
              marginTop: 2
            }, {
              children: "Adicione um ou mais v\u00EDdeos"
            })), jsxs(Text, Object.assign({
              variant: "body2",
              maxWidth: 290,
              textAlign: "center"
            }, {
              children: ["Voc\u00EA pode adicionar v\u00EDdeos no formato:", jsx("strong", {
                children: "mov, mp4, avi, mkv, aiff, mid, wav e outros..."
              })]
            }))]
          }))
        }))
      }), jsx(ModalActions, Object.assign({
        align: "center"
      }, {
        children: jsx(Button, Object.assign({
          onClick: addVideos,
          variant: "filled",
          fullWidth: true,
          disabled: !hasVideos,
          loading: isLoading,
          "data-testid": "add-videos-button"
        }, {
          children: "Adicionar v\u00EDdeos"
        }))
      }))]
    })
  }));
};

export { SendVideos };
